import {neverland as $, render, html, useState, useEffect} from 'neverland';

const LoadingProgressBar = $(function(progress, message = 'Loading...') {
	
	return html`
		<div class="loading-container">
			<div class="loading-content">
				<div class="loading-message">${message}</div>
				<div class="progress-bar">
					<div class="progress-fill" style="width: ${progress}%"></div>
				</div>
				<div class="progress-text">${Math.round(progress)}%</div>
			</div>
		</div>
	`;
});

export default LoadingProgressBar;